var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProfitReportTransactionsAdmin',{attrs:{"list":_vm.list,"total":_vm.total,"type":_vm.type}})
}
var staticRenderFns = []

export { render, staticRenderFns }